import { Layout, SignalTimesSystem } from "components"
export const SignalSchedule = () => {
 return (
  <Layout>
   <SignalTimesSystem />
  </Layout>
 )
}
